module.exports = __webpack_public_path__ + "03f02ff66048c11eb02d1875eb82a781.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_90.jpg
// module id = 1724
// module chunks = 5